/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/travel-booking-assistant.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Travel Booking Assistant',
  definitions: {
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            d="M16.0702 13.797C15.9028 13.4951 16.0118 13.1147 16.3137 12.9473C17.1235 12.4982 17.99 12.1895 18.8774 12.021C19.2165 11.9566 19.5436 12.1793 19.608 12.5184C19.6724 12.8575 19.4497 13.1846 19.1106 13.249C18.3516 13.3932 17.6113 13.6571 16.9199 14.0405C16.618 14.2079 16.2376 14.0989 16.0702 13.797Z"
            fill="#333333"
          />
          <path
            d="M15.279 25.7088C12.3989 22.8287 12.3989 18.1591 15.279 15.279C15.5231 15.0349 15.5231 14.6392 15.279 14.3951C15.0349 14.151 14.6392 14.151 14.3951 14.3951C11.0269 17.7634 11.0269 23.2244 14.3951 26.5927C14.6392 26.8368 15.0349 26.8368 15.279 26.5927C15.5231 26.3486 15.5231 25.9529 15.279 25.7088Z"
            fill="#333333"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.4939 20.4939C32.4939 27.1213 27.1214 32.4939 20.4939 32.4939C13.8665 32.4939 8.49395 27.1213 8.49395 20.4939C8.49395 13.8665 13.8665 8.49391 20.4939 8.49391C27.1214 8.49391 32.4939 13.8665 32.4939 20.4939ZM31.2439 20.4939C31.2439 26.431 26.431 31.2439 20.4939 31.2439C14.5569 31.2439 9.74395 26.431 9.74395 20.4939C9.74395 14.5569 14.5569 9.74391 20.4939 9.74391C26.431 9.74391 31.2439 14.5569 31.2439 20.4939Z"
            fill="#333333"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.1645 29.9218C33.4919 29.2493 33.3995 28.2022 33.8353 27.3568C34.8953 25.3002 35.4938 22.967 35.4938 20.4939C35.4938 12.2096 28.778 5.49391 20.4938 5.49391C12.2095 5.49391 5.49377 12.2096 5.49377 20.4939C5.49377 28.7782 12.2095 35.4939 20.4938 35.4939C22.9669 35.4939 25.3002 34.8954 27.3568 33.8353C28.2022 33.3995 29.2493 33.492 29.9219 34.1645L37.6777 41.9203C38.4587 42.7014 39.7251 42.7014 40.5061 41.9203L41.9203 40.5061C42.7014 39.725 42.7014 38.4587 41.9203 37.6777L34.1645 29.9218ZM34.2438 20.4939C34.2438 22.7631 33.6951 24.9005 32.7242 26.7841C32.0767 28.0402 32.1689 29.694 33.2806 30.8057L41.0364 38.5616C41.3293 38.8544 41.3293 39.3293 41.0364 39.6222L39.6222 41.0364C39.3293 41.3293 38.8545 41.3293 38.5616 41.0364L30.8057 33.2806C29.694 32.1689 28.0402 32.0768 26.7841 32.7242C24.9005 33.6952 22.763 34.2439 20.4938 34.2439C12.8999 34.2439 6.74377 28.0878 6.74377 20.4939C6.74377 12.9 12.8999 6.74391 20.4938 6.74391C28.0877 6.74391 34.2438 12.9 34.2438 20.4939Z"
            fill="#333333"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
